import Datatable from "./datatable_controller";

// Connects to data-controller="internal-event-category-datatable"
export default class extends Datatable {
  get columns() {
    return [
      { data: "name" },
      { data: "image" },
      { data: "subcategories_count" },
      { data: "actions" }
    ];
  }

  get searching() {
    return true;
  }

  get ordering() {
    return true;
  }

  get order() {
    return [[0, "asc"]];
  }

  get lengthChange() {
    return false;
  }
}
